import React, { useEffect, useRef } from "react";
import { completeSocialLoginAndRedirect } from "../../shared/utils/socialLoginComplete";

const GoogleOAuthCallback = () => {
  const startedRef = useRef(false);

  useEffect(() => {
    if (startedRef.current) return;
    const hasAuthError = new URLSearchParams(window.location.search).has(
      "auth_error"
    );
    if (hasAuthError) {
      return;
    }

    startedRef.current = true;
    completeSocialLoginAndRedirect().catch(() => {
      window.location.replace("/login");
    });
  }, []);

  return <div>Authorization...</div>;
};

export default GoogleOAuthCallback;
